import React, { Component, useEffect, useState } from 'react';
import ReferFriendView from './ReferFriendView';
import crmservices from '../../wsclient/crmservices';
import { isValidEmail, validPhoneNumber } from '../../utils/util';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import { getAppCfg, initOptionHeader, setContacts } from '../../utils/common';

function ReferFriend(props) {
    const auth_support = getAppCfg().auth_support;
    const isEmail = auth_support.email_password || auth_support.email_otp ? true : false;

    const [email, setEmail] = useState("");
    const [showLoading, onShowLoading] = useState(false);
    const [isValueNull, setIsValueNull] = useState(false);
    const [contact, setContact] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [loadingCode, onLoadingCode] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(()=>{
        onLoadContact();
    },[]) ;       

    const onLoadContact = async() =>{
        onLoadingCode(true);
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data);
            }
        } catch (error) {
            console.log("ReferFriendController on load contact exception:", error)
        }
        onLoadingCode(false);
    }

    const filterAndValidEmail = (value) =>{
        var email = value.email;
        //console.log('onRefer email =',email)
        var valid = [];
        var invalid = [];
        if (email) {
            var emails = email.split("\n");
            emails.forEach(element => {
                var emailIsValid = isEmail? isValidEmail(element): validPhoneNumber(element);
                if (emailIsValid) {
                    valid.push(element);
                } else {
                    invalid.push(element);
                }
            });
        }
        return { invalid: invalid, valid: valid };
    }
    const onRefer = async(value) =>{
        var filterEmail = filterAndValidEmail(value);
        var valid = filterEmail.valid;
        var referResult = {
            invalid: filterEmail.invalid
        };
        //console.log('onRefer valid =',valid)
        if (valid.length > 0) {
            onShowLoading(true);
            try {
                var result = await crmservices.rewards.sendRefferals({ recipients: valid });
                if (result.code === 'OK') {
                    referResult.valid = valid;
                    showAlert( t('SUCCESS'), t('refer_send_success'));
                    setIsValueNull(true);
                } else if(result.code=='TOO_MANY_REQUESTS'){
                    showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
                } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                    showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
                } else {
                    referResult.invalid = [...filterEmail.invalid, ...valid];
                    showAlert(t('SUCCESS'), t('EXCEPTION_PROCESS'));
                }
            } catch (error) {
                showAlert(t('SUCCESS'), t('EXCEPTION_PROCESS'));
            }
            onShowLoading(false);
            setResult(referResult);
        } else {
            setResult(referResult);
        }
    }
    const handleChange = () =>{
        setIsValueNull(false);
        }
    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = async() =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }
    return (
        <div>
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            <Loading showLoading={showLoading} />
            <ReferFriendView 
                onSubmit = {onRefer}  
                open={props.open}
                handleDrawerOtherToggle = {props.handleDrawerOtherToggle}
                result={result}
                isValueNull = {isValueNull}
                handleChange = {handleChange}
                contact={contact}
                loadingCode = {loadingCode}/>
                
        </div>
    );
}

export default ReferFriend;